import React from "react";
import { Modal, Input, Form, Checkbox } from "antd";
import { defaultFormLayout } from "../../../common/Utils";
import isSemVer from "validator/lib/isSemVer";

export const AddVersionDlg = ({ save, model, open, close, saving, check }) => {
  const [form] = Form.useForm();

  const onSave = () => {
    form.validateFields().then((values) => {
      save(values);
    });
  };

  return (
    <Modal
      title={`New ${model?.type} App Version`}
      visible={open}
      onOk={() => onSave()}
      maskClosable={false}
      confirmLoading={saving}
      onCancel={() => close()}
    >
      <Form form={form} {...defaultFormLayout}>
        <Form.Item
          label="New Version"
          validateTrigger={["onBlur", "onChange"]}
          hasFeedback
          name="version"
          rules={[
            { required: true, message: "Please input new version" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || isSemVer(value)) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Invalid version"));
              },
            }),
            ({ getFieldValue }) => ({
              validateTrigger: "onBlur",
              validator(_, value) {
                if (!value) return Promise.resolve();
                return check(value).then((msg) => {
                  if (msg) return Promise.reject(new Error(msg));
                  return Promise.resolve();
                });
              },
            }),
          ]}
        >
          <Input placeholder="Enter new version" />
        </Form.Item>
        <Form.Item label="Force Update" name="forceUpdate" valuePropName="checked">
          <Checkbox></Checkbox>
        </Form.Item>
        <Form.Item label="Notes" name="notes">
          <Input placeholder="Enter notes" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
